/* hivo-install-widget.js — v3 (month calendar) */
(function () {
  const OPTION_SLUG = 'haluan-tuotteen-asennettuna';
  const YES_VALUES = ['kyllä', 'yes', 'k']; // lower-case match
  const APP_PROXY_BASE = '/apps/hivo';
  const WIDGET_CLASS = 'hivo-install-widget';

  // ---------- Helpers ----------
  const normalize = v => (v || '').toString().trim().toLowerCase();
  const toISO = d => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${dd}`;
  };
  const parseISO = s => {
    const [y,m,dd] = s.split('-').map(n => parseInt(n,10));
    return new Date(y, m-1, dd);
  };
  const fiMonth = (d) => d.toLocaleDateString('fi-FI', { month: 'long', year: 'numeric' });
  const FI_WEEKDAYS = ['Ma','Ti','Ke','To','Pe','La','Su'];
  const EARLIEST_OFFSET_DAYS = 14;

  function addDays(base, n) {
    const d = new Date(base.getFullYear(), base.getMonth(), base.getDate() + n);
    d.setHours(12,0,0,0);
    return d;
  }

  // ---------- Widget factory ----------
  function createWidget(formId) {
    const wrap = document.createElement('div');
    wrap.className = WIDGET_CLASS;
    wrap.style.display = 'none';
    wrap.innerHTML = `
        <div>
        <label style="display:block;margin-bottom:.5rem;">Postinumero
            <input
            type="text"
            class="hivo-zip"
            inputmode="numeric"
            pattern="[0-9]*"
            maxlength="5"
            placeholder="esim. 40100"
            style="margin-top:.5rem;width:100%;padding:1rem;border:none;background-color:#FAFAFA;border-radius:.5rem"
            required
            >
        </label>

        <div class="hivo-cal-label" style="display:none;margin-top:1.5rem;">Valitse asennuspäivä</div>
        <div class="hivo-cal-root" style="margin-top:.5rem;" aria-live="polite"></div>

        <input type="hidden" name="properties[_asennus]" class="hivo-prop-asennus" ${formId ? `form="${formId}"` : ''} value="">
        <input type="hidden" name="properties[asennus_pvm]" class="hivo-prop-pvm" ${formId ? `form="${formId}"` : ''} value="">
        <input type="hidden" name="properties[postinumero]" class="hivo-prop-zip" ${formId ? `form="${formId}"` : ''} value="">
        </div>
    `;
    return wrap;
  }

  function readInstallValue(wrapper) {
    if (!wrapper) return '';
    const sel = wrapper.querySelector('select');
    if (sel) return normalize(sel.value);
    const radio = wrapper.querySelector('input[type="radio"]:checked');
    if (radio) return normalize(radio.value);
    const cb = wrapper.querySelector('input[type="checkbox"]');
    if (cb) return cb.checked ? 'kyllä' : 'ei';
    return '';
  }

  // ---------- Month calendar ----------
  function renderMonthCalendar(rootEl, freeISOdates, onPick, selectedISO) {
    // free dates as Set for O(1) checks
    const freeSet = new Set(freeISOdates);
    if (!freeISOdates.length) {
      rootEl.innerHTML = `<div style="margin:.25rem 0">Ei vapaita aikoja tällä alueella.</div>`;
      return;
    }

    // min/max month boundaries by free dates
    const minDate = parseISO(freeISOdates[0]);
    const maxDate = parseISO(freeISOdates[freeISOdates.length - 1]);

    // state: show month either where selected date is, else min month
    let view = selectedISO ? parseISO(selectedISO) : new Date(minDate);

    const header = document.createElement('div');
    header.style.display = 'flex';
    header.style.alignItems = 'center';
    header.style.justifyContent = 'space-between';
    header.style.margin = '.5rem 0';

    const prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.textContent = '‹';
    prevBtn.style.padding = '.25rem .5rem';
    prevBtn.style.border = 'none';
    prevBtn.style.background = 'transparent';
    prevBtn.style.fontSize = '1.1rem';
    prevBtn.style.cursor = 'pointer';

    const nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.textContent = '›';
    nextBtn.style.padding = '.25rem .5rem';
    nextBtn.style.border = 'none';
    nextBtn.style.background = 'transparent';
    nextBtn.style.fontSize = '1.1rem';
    nextBtn.style.cursor = 'pointer';

    const title = document.createElement('div');
    title.style.fontWeight = '600';

    const weekHead = document.createElement('div');
    weekHead.style.display = 'grid';
    weekHead.style.gridTemplateColumns = 'repeat(7, 1fr)';
    weekHead.style.gap = '.25rem';
    weekHead.style.fontSize = '.875rem';
    weekHead.style.opacity = '.8';
    weekHead.style.marginBottom = '.25rem';
    FI_WEEKDAYS.forEach(w => {
      const cell = document.createElement('div');
      cell.textContent = w;
      cell.style.textAlign = 'center';
      weekHead.appendChild(cell);
    });

    const grid = document.createElement('div');
    grid.style.display = 'grid';
    grid.style.gridTemplateColumns = 'repeat(7, 1fr)';
    grid.style.gap = '.25rem';

    rootEl.innerHTML = '';
    rootEl.append(header, weekHead, grid);

    header.append(prevBtn, title, nextBtn);

    function sameMonth(a,b){ return a.getFullYear()===b.getFullYear() && a.getMonth()===b.getMonth(); }
    function clampMonth(d){
      const beforeMin = new Date(d.getFullYear(), d.getMonth()+1, 0) < new Date(minDate.getFullYear(), minDate.getMonth(), 1);
      const afterMax = new Date(d.getFullYear(), d.getMonth(), 1) > new Date(maxDate.getFullYear(), maxDate.getMonth()+1, 0);
      if (beforeMin) return new Date(minDate);
      if (afterMax) return new Date(maxDate);
      return d;
    }

    function canPrev() {
      // previous month start must be >= min month start
      const prev = new Date(view.getFullYear(), view.getMonth()-1, 1);
      return !(prev < new Date(minDate.getFullYear(), minDate.getMonth(), 1));
    }
    function canNext() {
      // next month end must be <= max month end
      const next = new Date(view.getFullYear(), view.getMonth()+1, 1);
      return !(new Date(next.getFullYear(), next.getMonth()+1, 0) > new Date(maxDate.getFullYear(), maxDate.getMonth()+1, 0));
    }

    function render() {
      // header
      title.textContent = fiMonth(view);
      prevBtn.disabled = !canPrev();
      nextBtn.disabled = !canNext();
      prevBtn.style.opacity = prevBtn.disabled ? '.3' : '1';
      nextBtn.style.opacity = nextBtn.disabled ? '.3' : '1';

      grid.innerHTML = '';

      // Build grid: start from Monday of the first week shown
      const firstOfMonth = new Date(view.getFullYear(), view.getMonth(), 1);
      firstOfMonth.setHours(12,0,0,0);
      let start = new Date(firstOfMonth);
      const firstWeekday = (start.getDay() + 6) % 7;
      start.setDate(start.getDate() - firstWeekday);
      start.setHours(12,0,0,0);

      // up to 6 rows * 7 = 42 cells
      for (let i = 0; i < 42; i++) {
        const day = new Date(start.getFullYear(), start.getMonth(), start.getDate() + i);
        const dayISO = toISO(day);
        const inMonth = sameMonth(day, view);
        const selectable = freeSet.has(dayISO);

        const cell = document.createElement('div');
        cell.style.textAlign = 'center';

        if (selectable) {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.textContent = String(day.getDate());
          btn.style.width = '100%';
          btn.style.padding = '.6rem 0';
          btn.style.border = 'none';
          btn.style.borderRadius = '.5rem';
          btn.style.cursor = 'pointer';
          btn.style.background = selectedISO === dayISO ? '#111' : '#FAFAFA';
          btn.style.color = selectedISO === dayISO ? '#fff' : '#111';
          btn.addEventListener('click', () => {
            selectedISO = dayISO;
            onPick(dayISO);
            render(); // re-render selection state
          });
          cell.appendChild(btn);
        } else {
          const span = document.createElement('div');
          span.textContent = String(day.getDate());
          span.style.width = '100%';
          span.style.padding = '.6rem 0';
          span.style.borderRadius = '.5rem';
          span.style.opacity = inMonth ? '.35' : '.15';
          span.style.background = 'transparent';
          cell.appendChild(span);
        }

        // gray out days not in current month slightly
        if (!inMonth) cell.style.opacity = '.6';

        grid.appendChild(cell);
      }
    }

    prevBtn.addEventListener('click', () => { if (canPrev()) { view = clampMonth(new Date(view.getFullYear(), view.getMonth()-1, 1)); render(); } });
    nextBtn.addEventListener('click', () => { if (canNext()) { view = clampMonth(new Date(view.getFullYear(), view.getMonth()+1, 1)); render(); } });

    render();
  }

  // ---------- Availability loader ----------
  async function loadAvailability(zip, calRoot, onPick, selectedISORef) {
    const labelEl = calRoot.parentElement.querySelector('.hivo-cal-label');
    calRoot.textContent = 'Ladataan vapaita aikoja…';
    labelEl.style.display = 'none';
    try {
        const res = await fetch(`${APP_PROXY_BASE}/availability?postinro=${encodeURIComponent(zip)}&tyyppi=laturit`, { credentials:'same-origin' });
        if (!res.ok) throw new Error('Saatavuushaun virhe');
        const data = await res.json();
        const dates = Array.isArray(data.dates) ? data.dates.slice().sort() : [];
        const today = new Date(); today.setHours(12,0,0,0);
        const earliest = addDays(today, EARLIEST_OFFSET_DAYS);
        const earliestISO = toISO(earliest);
        const filtered = dates.filter(d => d >= earliestISO);
        const useDates = filtered;
        if (!useDates.length) {
          calRoot.innerHTML = '<div style="margin:.25rem 0">Ei vapaita aikoja tällä alueella.</div>';
          return;
        }
        labelEl.style.display = 'block';
        renderMonthCalendar(calRoot, useDates, (pickedISO) => {
          selectedISORef.value = pickedISO;
          onPick(pickedISO);
        }, selectedISORef.value);
    } catch (e) {
        console.error(e);
        calRoot.textContent = 'Aikojen haku epäonnistui. Tarkista postinumero tai yritä uudelleen.';
    }
  }

  // ---------- Attach per variant-selects ----------
  function attachToVariantSelects(vsEl){
    if (vsEl.dataset.hivoInited === '1') return;
    vsEl.dataset.hivoInited = '1';

    const formId = vsEl.getAttribute('form');
    const form = formId ? document.getElementById(formId) : vsEl.closest('form[action*="/cart/add"]');
    if (!form) return;

    const installWrapper = vsEl.querySelector(`.variant-input-wrapper[data-option-slug="${OPTION_SLUG}"]`);
    if (!installWrapper) return;

    // Ensure single widget under this variant-selects
    let widget = vsEl.querySelector(`:scope > .${WIDGET_CLASS}`);
    if (!widget) {
      widget = createWidget(formId);
      installWrapper.insertAdjacentElement('afterend', widget);
    }

    const zipInput = widget.querySelector('.hivo-zip');
    const calRoot = widget.querySelector('.hivo-cal-root');
    const propAsennus = widget.querySelector('.hivo-prop-asennus');
    const propPvm = widget.querySelector('.hivo-prop-pvm');
    const propZip = widget.querySelector('.hivo-prop-zip');

    // maintain selected date across re-renders in this widget
    const selectedISORef = { value: '' };

    function showWidget(){ widget.style.display='block'; }
    function hideWidget(){
      widget.style.display='none';
      const labelEl = widget.querySelector('.hivo-cal-label');
      labelEl.style.display = 'none';
      propAsennus.value=''; propPvm.value=''; propZip.value='';
      calRoot.innerHTML='';
      selectedISORef.value = '';
    }

    const onOptionChange = () => {
      const val = readInstallValue(installWrapper);
      if (YES_VALUES.includes(normalize(val))) showWidget(); else hideWidget();
    };
    installWrapper.addEventListener('change', onOptionChange);
    onOptionChange(); // initial

    zipInput.addEventListener('input', () => {
      propZip.value = '';
      propPvm.value = '';
      calRoot.innerHTML = '';
      selectedISORef.value = '';
      const zip = zipInput.value.trim();
      const labelEl = widget.querySelector('.hivo-cal-label');
      labelEl.style.display = 'none';
      if (zip.length === 5) {
        propZip.value = zip;
        loadAvailability(zip, calRoot, (pickedISO) => {
          propAsennus.value = 'kyllä';
          propPvm.value = pickedISO;
          propZip.value = zip;
        }, selectedISORef);
      }
    });

    // Guard submit reliably
    const submitGuard = (e) => {
      const visible = widget.style.display !== 'none';
      if (!visible) return;
      if (!propZip.value || propZip.value.length !== 5) {
        e.preventDefault(); e.stopImmediatePropagation();
        alert('Anna postinumero.');
        return;
      }
      if (!propPvm.value) {
        e.preventDefault(); e.stopImmediatePropagation();
        alert('Valitse asennuspäivä kalenterista.');
        return;
      }
    };
    form.addEventListener('submit', submitGuard, true);
  }

  function init() {
    document.querySelectorAll('variant-selects').forEach(attachToVariantSelects);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();